import {
  getAuthDataSelector,
  getAuthSessionTokenSelector,
} from "@common/redux/auth/selectors";
import { getStore } from "@common/utils/storeInjection";

export const getAuthSessionToken = () => {
  const store = getStore();
  const reduxState = store.getState();
  return getAuthSessionTokenSelector(reduxState);
};

export const getAuthData = () => {
  const store = getStore();
  const reduxState = store.getState();
  return getAuthDataSelector(reduxState);
};

export enum errorCodes {
  ERR_FORM_ALREADY_RESPONDED = "ERR008",
  ERR_NOT_REGISTERED_MOBILE_OR_EMAIL = "ERR0010",
  ERR_WRONG_EMAIL_AND_PASSWORD = "ERR0009",
  SUBMISSION_CLOSED = "ERR0012",
  ERR_ALREADY_REGISTERED = "ERR0013",
  ERR_ORGANIZATION_ALREADY_REGISTERED = "ERR0003",
  DATA_NOT_FOUND = "ERR404",
}
